//import React, { useState, useEffect } from 'react';
import React, { useState, useEffect, useMemo } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Modal } from '@mui/material';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ReportShell, { RC, dateInp, refreshBtn, excelBtn, thStyle } from './ReportShell';

function TrialBalanceReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [financialDate, setFinancialDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, companyName, permissions, username, token, logout } = useAuth();
    const [reportGeneratedTime, setReportGeneratedTime] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        setFinancialDate(getFormattedStartFinancialDate());
    }, [isAuthenticated, companyId, token, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };

    const getFormattedStartFinancialDate = () => {
        const monthStartFinancialDate = new Date();
        monthStartFinancialDate.setDate(1);
        return monthStartFinancialDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    const handleFinancialDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFinancialDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [isLoading, setIsLoading] = useState(false);

    const filteredDataItem = useMemo(() => {
        return dataItem;
    }, [dataItem]);

    const fetchTableData = async () => {
        setDataItem([]);
        setIsLoading(true);
        const now = new Date();
        const formattedDateTime =
            String(now.getDate()).padStart(2, '0') + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            now.getFullYear() + ' ' +
            now.toLocaleTimeString(); // e.g., 10:45:23 AM

        setReportGeneratedTime(formattedDateTime);

        try {
            const branchId = 0;
            const response = await fetchData(
                "ReportApi",
                `/TrialBalanceDetails/${branchId}/${fromDate}/${toDate}/${financialDate}/${companyId}`,
                token
            );

            if (response.responseCode === "1111") {
                setDataItem(response.response_data);
            } else {
                console.warn("Unexpected response code:", response.responseCode);
            }
        } catch (error) {
            console.error("Error fetching Trial Balance Details:", error.message);
        } finally {
            setIsLoading(false);
        }
    };
    const [selectedAccount, setSelectedAccount] = useState(null); // For AccountName and other details

    useEffect(() => {
        fetchTableData();
    }, []);


    // const handleExportToExcel = () => {
    //     const now = new Date();
    //     const generatedDateTime =
    //         String(now.getDate()).padStart(2, '0') + '-' +
    //         String(now.getMonth() + 1).padStart(2, '0') + '-' +
    //         now.getFullYear() + ' ' +
    //         now.toLocaleTimeString();

    //     const headerRows = [
    //         ["Trial Balance"],
    //         [`As On ${toDate}`],
    //         [`Report Generated: ${generatedDateTime}`],
    //         [],
    //         ["Head", "Particulars", "Debit", "Credit"]
    //     ];

    //     const worksheet = XLSX.utils.aoa_to_sheet(headerRows);

    //     worksheet['!cols'] = [
    //         { wch: 15 },
    //         { wch: 30 },
    //         { wch: 15 },
    //         { wch: 15 }
    //     ];

    //     let currentHeadName = null;
    //     let rowIndex = headerRows.length;

    //     filteredDataItem.forEach((data) => {
    //         if (data.headName && data.headName !== currentHeadName) {
    //             currentHeadName = data.headName;
    //             XLSX.utils.sheet_add_aoa(worksheet, [[data.headName, "", "", ""]], { origin: `A${++rowIndex}` });
    //             rowIndex++;
    //         }

    //         const debit = parseFloat(data.TotalDebitSum || 0);
    //         const credit = parseFloat(data.TotalCreditSum || 0);

    //         XLSX.utils.sheet_add_aoa(worksheet, [[
    //             "",
    //             data.AccountName,
    //             debit,
    //             credit
    //         ]], { origin: `A${++rowIndex}` });

    //         // Apply number format for debit and credit cells:
    //         worksheet[`C${rowIndex}`].z = "0.00";  // 2 decimal places
    //         worksheet[`D${rowIndex}`].z = "0.00";
    //     });

    //     const totalDebit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalDebitSum || 0), 0);
    //     const totalCredit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalCreditSum || 0), 0);

    //     XLSX.utils.sheet_add_aoa(worksheet, [["Total", "", totalDebit, totalCredit]], { origin: `A${++rowIndex}` });

    //     worksheet[`C${rowIndex}`].z = "0.00"; // total debit format
    //     worksheet[`D${rowIndex}`].z = "0.00"; // total credit format

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Trial Balance");
    //     XLSX.writeFile(workbook, "TrialBalance.xlsx");
    // };

    const handleExportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Trial Balance");
        worksheet.views = [{ state: 'frozen', ySplit: 4 }];

        const now = new Date();
        const generatedDateTime =
            String(now.getDate()).padStart(2, '0') + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            now.getFullYear() + ' ' +
            now.toLocaleTimeString();

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 HEADER SECTION
        worksheet.mergeCells('A1:D1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = 'Trial Balance';
        titleCell.font = { bold: true, size: 12 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.mergeCells('A2:D2');
        const dateCell = worksheet.getCell('A2');
        dateCell.value = `As On ${toDate}`;
        dateCell.font = { italic: true, size: 10 };
        dateCell.alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.mergeCells('A3:D3');
        const generatedCell = worksheet.getCell('A3');
        generatedCell.value = `Report Generated: ${generatedDateTime}`;
        generatedCell.font = { size: 9 };
        generatedCell.alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.addRow([]);

        // 🔹 COLUMN HEADERS
        const headerRow = worksheet.addRow(["Head", "Particulars", "Debit", "Credit"]);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
        });

        // 🔹 DATA SECTION
        let currentHeadName = null;
        let balRowStart = worksheet.rowCount + 1;

        filteredDataItem.forEach((data) => {
            if (data.headName && data.headName !== currentHeadName) {
                currentHeadName = data.headName;

                const headRow = worksheet.addRow([data.headName, "", "", ""]);
                headRow.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFCE5CD' }, // Light orange for Head
                    };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                });
            }

            const debit = parseFloat(data.TotalDebitSum || 0);
            const credit = parseFloat(data.TotalCreditSum || 0);

            const row = worksheet.addRow(["", data.AccountName, debit, credit]);
            row.eachCell((cell, colNum) => {
                cell.border = thinBorder;
                if (colNum === 3 || colNum === 4) {
                    cell.alignment = { horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left' };
                }
            });
        });

        // 🔹 TOTAL ROW
        const totalDebit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalDebitSum || 0), 0);
        const totalCredit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalCreditSum || 0), 0);

        const totalRow = worksheet.addRow(["Total", "", totalDebit, totalCredit]);
        totalRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF4CCCC' }, // Light pink for total
            };
            cell.alignment = { horizontal: 'right', vertical: 'middle' };
            if (cell.col === 3 || cell.col === 4) {
                cell.numFmt = '#,##0.00';
            }
        });

        // 🔹 ADJUST COLUMN WIDTHS
        worksheet.columns = [
            { width: 20 }, // Head
            { width: 40 }, // Particulars
            { width: 15 }, // Debit
            { width: 15 }, // Credit
        ];

        // 🔹 EXPORT FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `Trial_Balance_AsOn_${toDate.replace(/\//g, '-')}.xlsx`
        );
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    };

    //Customer Ledger  
    const [CustomerLedgermodel, setCustomerLedgermodal] = useState(false);
    const [CustomerLedgerFilteredData, setCustomerLedgerFilteredData] = useState([]);

    const openCustomerLedgermodal = async () => {
        console.log('Opening route data modal');
        //await handlePendingBillClick();
        //handleCustomerLedgerClick();
        setCustomerLedgermodal(true);
    };


    const handleCustomerLedgerClick = async (headid, accountName) => {
        setSelectedAccount({ headid, accountName }); // Store the clicked account's details
        setCustomerLedgerFilteredData([]); // Clear previous data
        try {
            const response = await fetchData(
                "ReportApi",
                `/Ledger/${companyId}/${headid}/${fromDate}/${toDate}`,
                token
            );
            if (response.responseCode === "1111") {
                setCustomerLedgerFilteredData(response.response_data);
                setCustomerLedgermodal(true); // Open modal
            } else {
                console.error("Invalid response code:", response.responseCode);
            }
        } catch (error) {
            console.error("Error fetching ledger data:", error);
        }
    };

    const closeCustomerLedgerModal = () => {
        console.log('Closing modal');
        setCustomerLedgermodal(false);
    };


    const handleExportCashBookExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Cash Book');
        worksheet.views = [{ state: 'frozen', ySplit: 2 }];

        let bal = 0;

        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        const customerLabel = selectedAccount?.accountName || 'Cash Book';
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 Header Title Row
        worksheet.mergeCells('A1:E1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `${companyName} - Cash Book for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        // 🔹 Column Headers
        const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green header
            };
        });

        // 🔹 Data Rows
        CashBookilteredData.forEach((rowData) => {
            let rowValues;

            if (['Opening Balance', 'Closing Balance', 'Total'].includes(rowData.description1)) {
                rowValues = [
                    '',
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : '',
                ];
            } else {
                rowValues = [
                    formatDate(rowData.billdate),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData),
                ];
            }

            const row = worksheet.addRow(rowValues);

            // 🔸 Style total or closing rows differently
            if (['Closing Balance', 'Total'].includes(rowData.description1)) {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                    cell.font = { bold: true };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
                });
            } else {
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        // 🔹 Adjust column widths
        worksheet.columns = [
            { width: 15 },
            { width: 35 },
            { width: 15 },
            { width: 15 },
            { width: 20 },
        ];

        // 🔹 Save file
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedLabel = customerLabel.replace(/[^\w]/g, '_');
        saveAs(
            new Blob([buffer]),
            `Cash_Book_${sanitizedLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    // const handleExportCashBookExcel = () => {
    //     const excelData = [];
    //     let copbal = 0; // Cumulative opening balance for credit
    //     let dopbal = 0; // Cumulative opening balance for debit
    //     let bal = 0;    // Running balance

    //     // Helper function to compute balance
    //     const computeBalance = (data) => {
    //         // if (data.description1 === 'Opening Balance') {
    //         //     bal = 0; // Reset balance for opening balance
    //         // } else 
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             // Add debit to balance
    //             if (data.debit) {
    //                 bal += Math.abs(data.debit);
    //             }
    //             // Subtract credit from balance
    //             if (data.credit) {
    //                 bal -= Math.abs(data.credit);
    //             }
    //         }

    //         // Return balance string with "Dr" or "Cr"
    //         //data.description1 !== 'Opening Balance' &&
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
    //         }
    //         return '';
    //     };

    //     // Ensure selectedCustomer is handled properly
    //     //const customerLabel = selectedChildOption ? selectedChildOption.label : 'Cash Book';

    //     const customerLabel = selectedAccount?.accountName || 'Cash Book';

    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     // Add header caption
    //     const headerCaption = [
    //         [`Cash Book From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`]
    //     ];
    //     excelData.push(...headerCaption);

    //     // Add column headers
    //     const headerRow = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
    //     excelData.push(headerRow);

    //     // Add data rows
    //     CashBookilteredData.forEach((rowData) => {
    //         const dataRow = [];
    //         if (rowData.description1 === 'Opening Balance') {
    //             // Display balances under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 computeBalance(rowData)
    //             );

    //         } else if (rowData.description1 === 'Closing Balance') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         }

    //         else if (rowData.description1 === 'Total') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         } else {
    //             // For regular rows
    //             dataRow.push(
    //                 formatDate(rowData.billdate), // Format the date
    //                 rowData.description1,
    //                 rowData.debit != null ? parseFloat(rowData.debit.toFixed(2)) : '',
    //                 rowData.credit != null ? parseFloat(rowData.credit.toFixed(2)) : '',
    //                 computeBalance(rowData) // Compute and add balance
    //             );
    //         }
    //         excelData.push(dataRow);
    //     });

    //     // Create a worksheet
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    //     // Style the worksheet to right-align specific columns
    //     const columnIndexesToRightAlign = [2, 3, 4]; // Debit, Credit, and Balance columns
    //     const range = XLSX.utils.decode_range(worksheet['!ref']);

    //     for (let row = 1; row <= range.e.r; row++) { // Start from row 1 (skip header)
    //         columnIndexesToRightAlign.forEach((colIndex) => {
    //             const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
    //             if (worksheet[cellAddress]) {
    //                 worksheet[cellAddress].s = { alignment: { horizontal: 'right' } };
    //             }
    //         });
    //     }

    //     // Create workbook and add the worksheet
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Cash Book');

    //     // Filename sanitization for spaces and special characters
    //     const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
    //     XLSX.writeFile(workbook, `Cash_Book_From_${formatDate(fromDate).replace(/[/]/g, '-')}_To_${formatDate(toDate).replace(/[/]/g, '-')}.xlsx`);
    // };



    const handleExportLedgerExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Ledger');

        worksheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 2 }]; // Freeze top two rows

        let bal = 0;

        // --- Compute Balance Function ---
        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        const customerLabel = selectedAccount?.accountName || 'Ledger';
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        const thinBorder = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } },
        };

        // --- Header Title Row ---
        worksheet.mergeCells('A1:E1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `${companyName} - Ledger for ${customerLabel}\nFrom: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime}`;
        headerCell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        headerCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF305496' }, // Dark blue header background
        };
        worksheet.getRow(1).height = 30;

        // --- Column Headers ---
        const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF4F81BD' }, // Blue
            };
        });
        worksheet.getRow(2).height = 20;

        // --- Data Rows ---
        CustomerLedgerFilteredData.forEach((rowData, index) => {
            let rowValues;

            if (['Opening Balance', 'Closing Balance', 'Total'].includes(rowData.description1)) {
                rowValues = [
                    '',
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : ''
                ];
            } else {
                rowValues = [
                    formatDateForInput(rowData.date1),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData)
                ];
            }

            const row = worksheet.addRow(rowValues);

            // --- Alternate Row Shading (Zebra Effect) ---
            if (index % 2 === 0) {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF2F2F2' }, // Light gray
                    };
                });
            }

            // --- Highlight Total or Closing Balance Rows ---
            if (rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFC7CE' }, // Light red
                    };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                });
            } else {
                // Regular row styling
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right', vertical: 'middle' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left', vertical: 'middle' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        // --- Adjust column widths ---
        worksheet.columns = [
            { width: 14 }, // Date
            { width: 40 }, // Description
            { width: 15 }, // Debit
            { width: 15 }, // Credit
            { width: 15 }, // Balance
        ];

        // --- Add bottom padding row ---
        worksheet.addRow([]);
        worksheet.getRow(worksheet.lastRow.number).height = 10;

        // --- Export to file ---
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');

        saveAs(
            new Blob([buffer]),
            `Ledger_${sanitizedCustomerLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    //Customer Ledger  
    const [CashBookmodel, setCashBookmodal] = useState(false);
    const [CashBookilteredData, setCashBookFilteredData] = useState([]);

    const openCashBookmodal = async () => {
        console.log('Opening route data modal');
        //await handlePendingBillClick();
        //handleCustomerLedgerClick();
        setCashBookmodal(true);
    };

    const handleCashBookClick = async (headid, accountName) => {
        setCashBookFilteredData([]); // Clear previous data
        try {
            const response = await fetchData('ReportApi', `/CashBook/${fromDate}/${toDate}/${companyId}`, token);
            if (response.responseCode === "1111") {
                setCashBookFilteredData(response.response_data);
                setCashBookmodal(true); // Open modal
                setCustomerLedgerFilteredData([]); // Clear Customer Ledger data if needed
                setCustomerLedgermodal(false);

            } else {
                console.error("Invalid response code:", response.responseCode);
            }
        } catch (error) {
            console.error("Error fetching ledger data:", error);
        }
    };

    const closeCashBookModal = () => {
        console.log('Closing modal');
        setCashBookmodal(false);
    };

    const handleRowClick = (headid, accountName, headName) => {
        if (headName === "Cash In Hand") {
            handleCashBookClick(headid, accountName); // Open CashBook modal
        } else if (
            ["Sundry Creditors", "Sundry Debtors", "Staff", "Income (Direct)", "Expenses (Direct)", "Direct Expenses", "Capital Account"].includes(headName)
        ) {
            handleCustomerLedgerClick(headid, accountName); // Open Ledger modal
        } else {
            console.log("No action required for this headName:", headName);
        }
    };

    let copbal = 0; // Cumulative opening balance for credit
    let dopbal = 0; // Cumulative opening balance for debit
    let bal = 0;    // Running balance

    const computeBalance = (data) => {

        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
        }
        return '';
    };


    return (
        <ReportShell
            title="TRIAL BALANCE"
            recordCount={filteredDataItem.length}
            filters={<>
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px' }}>From</span>
                <input type="date" value={fromDate} onChange={handleFromDateChange} style={{ ...dateInp, width: '130px' }} />
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px', marginLeft: '8px' }}>To</span>
                <input type="date" value={toDate} onChange={handleToDateChange} style={{ ...dateInp, width: '130px' }} />
                {reportGeneratedTime && (
                    <span style={{ fontSize: '10px', color: RC.muted }}>Generated: {reportGeneratedTime}</span>
                )}
            </>}
            actions={<>
                <button onClick={fetchTableData} disabled={isLoading} style={{ ...refreshBtn, opacity: isLoading ? 0.7 : 1 }}>
                    {isLoading ? 'Loading...' : 'Refresh'}
                </button>
                <button onClick={handleExportToExcel} style={excelBtn}>Excel</button>
            </>}
            loading={isLoading}
        >
            <TableContainer component={Paper}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ ...thStyle, width: 32 }}>#</TableCell>
                            <TableCell style={{ ...thStyle, textAlign: 'left' }}>Account Name</TableCell>
                            <TableCell style={{ ...thStyle, textAlign: 'right' }}>Debit</TableCell>
                            <TableCell style={{ ...thStyle, textAlign: 'right' }}>Credit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredDataItem.length === 0 ? (
                            <TableRow><TableCell colSpan={4} sx={{ textAlign: 'center', padding: '24px', color: '#5a7a7a', fontSize: '12px' }}>No data — select a date range and click Refresh</TableCell></TableRow>
                        ) : (
                            filteredDataItem.map((data, index) => {
                                const isNewHead = index === 0 || data.headName !== filteredDataItem[index - 1].headName;
                                return (
                                    <React.Fragment key={data.headid || index}>
                                        {isNewHead && (
                                            <TableRow sx={{ backgroundColor: 'rgba(45,212,191,0.08)' }}>
                                                <TableCell colSpan={4} sx={{ fontWeight: 700, fontSize: '11px', color: '#14b8a6', padding: '4px 8px' }}>{data.headName}</TableCell>
                                            </TableRow>
                                        )}
                                        <TableRow onClick={() => handleRowClick(data.headid, data.AccountName, data.headName)} sx={{
                                            cursor: 'pointer',
                                            backgroundColor: index % 2 === 0 ? '#fdfdfd' : '#f7fdfc',
                                            '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' },
                                        }}>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', color: '#5a7a7a' }}>{index + 1}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', fontWeight: 600, color: data.AccountName === 'Hold' ? '#dc2626' : '#1a2e2e' }}>{data.AccountName}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{parseFloat(data.TotalDebitSum || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{parseFloat(data.TotalCreditSum || 0).toFixed(2)}</TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })
                        )}
                        {!isLoading && filteredDataItem.length > 0 && (() => {
                            const totalDebit = filteredDataItem.reduce((s, d) => s + parseFloat(d.TotalDebitSum || 0), 0);
                            const totalCredit = filteredDataItem.reduce((s, d) => s + parseFloat(d.TotalCreditSum || 0), 0);
                            return (
                                <TableRow sx={{ backgroundColor: '#f0f4f4' }}>
                                    <TableCell colSpan={2} sx={{ fontWeight: 700, padding: '5px 8px', fontSize: '12px', textAlign: 'right' }}>Total</TableCell>
                                    <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{totalDebit.toFixed(2)}</TableCell>
                                    <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{totalCredit.toFixed(2)}</TableCell>
                                </TableRow>
                            );
                        })()}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Ledger Modal */}
            <Modal open={CustomerLedgermodel} onClose={closeCustomerLedgerModal}>
                <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1300, paddingTop: 40 }}>
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', width: '90%', maxHeight: '90vh', overflowY: 'auto', padding: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <span style={{ fontWeight: 800, fontSize: 13, color: '#1a2e2e' }}>LEDGER — <span style={{ color: '#dc2626' }}>{selectedAccount?.accountName}</span></span>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button onClick={handleExportLedgerExcel} style={excelBtn}>Excel</button>
                                <button onClick={closeCustomerLedgerModal} style={{ ...refreshBtn, color: '#dc2626' }}>Close</button>
                            </div>
                        </div>
                        <TableContainer component={Paper}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        {[['Date','left'],['Description','left'],['Debit','right'],['Credit','right'],['Balance','right']].map(([col, align]) => (
                                            <TableCell key={col} style={{ ...thStyle, textAlign: align }}>{col}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {CustomerLedgerFilteredData.map((data, index) => {
                                        const isSpecial = ['Opening Balance','Closing Balance','Total'].includes(data.description1);
                                        return (
                                            <TableRow key={data.id || index} sx={{ backgroundColor: isSpecial ? '#f0f4f4' : index % 2 === 0 ? '#fdfdfd' : '#f7fdfc' }}>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px' }}>{isSpecial ? '' : formatDateForInput(data.date1)}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', fontWeight: isSpecial ? 700 : 400 }}>
                                                    {data.tbl1 === 'Sale' ? <a href={`/SaleDetails/${data.id}`} target="_blank" rel="noopener noreferrer" style={{ color: 'darkgreen' }}>{data.description1}</a>
                                                    : data.tbl1 === 'Purchase' ? <a href={`/PurchaseDetails/${data.id}`} target="_blank" rel="noopener noreferrer" style={{ color: 'darkcyan' }}>{data.description1}</a>
                                                    : data.description1}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', textAlign: 'right', fontWeight: isSpecial ? 700 : 400 }}>{data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', textAlign: 'right', fontWeight: isSpecial ? 700 : 400 }}>{data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', textAlign: 'right', fontWeight: 700 }}>{computeBalance(data)}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Modal>

            {/* CashBook Modal */}
            <Modal open={CashBookmodel} onClose={closeCashBookModal}>
                <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1300, paddingTop: 40 }}>
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', width: '90%', maxHeight: '90vh', overflowY: 'auto', padding: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <span style={{ fontWeight: 800, fontSize: 13, color: '#1a2e2e' }}>CASH BOOK</span>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button onClick={handleExportCashBookExcel} style={excelBtn}>Excel</button>
                                <button onClick={closeCashBookModal} style={{ ...refreshBtn, color: '#dc2626' }}>Close</button>
                            </div>
                        </div>
                        <TableContainer component={Paper}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        {[['Date','left'],['Description','left'],['Debit','right'],['Credit','right'],['Balance','right']].map(([col, align]) => (
                                            <TableCell key={col} style={{ ...thStyle, textAlign: align }}>{col}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {CashBookilteredData.map((data, index) => {
                                        const isSpecial = ['Opening Balance','Closing Balance','Total'].includes(data.description1);
                                        return (
                                            <TableRow key={data.id || index} sx={{ backgroundColor: isSpecial ? '#f0f4f4' : index % 2 === 0 ? '#fdfdfd' : '#f7fdfc' }}>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px' }}>{isSpecial ? '' : formatDate(data.billdate)}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', fontWeight: isSpecial ? 700 : 400 }}>{data.description1}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', textAlign: 'right', fontWeight: isSpecial ? 700 : 400 }}>{data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', textAlign: 'right', fontWeight: isSpecial ? 700 : 400 }}>{data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>
                                                <TableCell sx={{ fontSize: '12px', padding: '4px 8px', textAlign: 'right', fontWeight: 700 }}>{computeBalance(data)}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Modal>
        </ReportShell>
    );
}

export default TrialBalanceReport;
